/**
 * A small colored pill for contact statuses. Falls back to a neutral chip
 * when the status is unknown (e.g. the row's status_id was deleted at the
 * platform level).
 */
export default function ContactStatusChip({ status, className = "" }) {
  if (!status) {
    return (
      <span
        className={`inline-flex items-center rounded-full bg-zinc-100 px-2 py-0.5 text-[11px] font-medium text-zinc-500 ${className}`}
        data-testid="contact-status-chip"
      >
        —
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${className}`}
      style={{
        backgroundColor: `${status.color}1a`,
        color: status.color,
      }}
      data-testid={`contact-status-chip-${status.id}`}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: status.color }}
      />
      {status.name}
    </span>
  );
}
